import mixpanel from 'mixpanel-browser';
import { FLAVOR, SECRETS_ENV } from '../Config/firebase';

// Initialize Mixpanel with token from secrets (shared with Plundr project)
mixpanel.init(SECRETS_ENV.MIXPANEL_TOKEN);

const envCheck = FLAVOR === 'PRODUCTION' || FLAVOR === 'DEVELOPMENT';

const actions = {
  identify: (id: string) => {
    if (envCheck) mixpanel.identify(id);
  },

  alias: (id: string) => {
    if (envCheck) mixpanel.alias(id);
  },

  track: (name: string, props?: Record<string, any>) => {
    if (envCheck) mixpanel.track(name, props);
  },

  people: {
    set: (props: Record<string, any>) => {
      if (envCheck) mixpanel.people.set(props);
    },
  },

  reset: () => {
    if (envCheck) mixpanel.reset();
  },
};

export const Mixpanel = actions;
